// company-overview.component.ts
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ApiService } from '../../shared/services/api.service';
import { ToastrMsgService } from '../../shared/services/shared-services/toastr.service';


@Component({
  selector: 'app-company-info',
  standalone: false,
  templateUrl: './company-info.component.html',
  styleUrl: './company-info.component.css'
})
export class CompanyInfoComponent {
  orgForm!: FormGroup;

  machineType: any;
  errorMessage1: any;
 
  submitted = false;
  imageurl: any;
  file: any;

  companyForm: FormGroup;
  organizationId: any;

  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService
  ) {



  }


  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];
    });
    if (this.organizationId) {
      this.getOrganizationDetails();
    }
    this.orgForm = this.formBuilder.group({
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: [""],
      gst_number: [""],
      pan_number: [""],
      address: [""],
      city: [""],
      state: [""],
      postal_code: [""],
      country: [""],
      primary_contact_name: [""],
      primary_contact_email: [""],
      primary_contact_phone: [""],
      onboarding_date: [""],
      status: [false],
      metadata: ["{}"],
      // domain: ["", Validators.required],
      // membership_start_date: ["", Validators.required],
      // membership_end_date: ["", Validators.required],
      // uniqueCode: ["", Validators.required],
      // primaryContact: this.formBuilder.group({
      //   name: ["", Validators.required],
      //   email: ["", [Validators.required, Validators.email]],
      //   role: ["", Validators.required],
      //   mobile: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      // }),

    });

  }

  get keyContacts(): FormArray {
    return this.orgForm.get("keyContacts") as FormArray;
  }

  addKeyContact() {
    const contactGroup = this.formBuilder.group({
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      role: ["", Validators.required],
      mobile: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
    this.keyContacts.push(contactGroup);
  }

  removeContact(index: number) {
    this.keyContacts.removeAt(index);
  }

  handleFileInput(event: any) {
    this.file = event.target.files[0];
    const fileSize = this.file.size / 1024 / 1024; // Convert bytes to KB
    const fileType = this.file.type;

    if (!this.file) {
      // this.errorMessage1 = 'No file chosen.';
      return;
    }

    if (fileType !== "image/jpeg" && fileType !== "image/png") {
      this.errorMessage1 = "File should be JPEG or PNG.";
      return;
    }

    if (fileSize > 3) {
      this.errorMessage1 = "File size should be less than 3 MB.";
      return;
    }

    this.imageurl = URL.createObjectURL(this.file);
  }

  onSubmit(): void {
    if (this.organizationId) {
      this.update(this.organizationId);
    } else {
      this.apiService.saveOrganization(this.orgForm.value).subscribe({
        next: (res) => {
          this.toastrMsgService.success('Organization added successfully');
          this.router.navigate(['/home/organization-list']);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => console.log("Observable complete"),
      });
    }
  }
  update(id: any): void {
    this.apiService.updateOrganization(id, this.orgForm.value).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Organization Updated successfully');
        // Mark onboarding complete for invited org admins
        this.apiService.completeOrganizationOnboarding().subscribe({
          next: () => {},
          error: () => {},
        });
        this.router.navigate(['home/dashboard']);
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });

  }
 
  getOrganizationDetails() {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {
        console.log(res);
        const data = res.data.find((project: any) => project.org_id == this.organizationId);
        this.orgForm.patchValue(data);
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }
}
